module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matches"
  }, [_c('header-bar'), _vm._v(" "), (!_vm.uiHideInstructions) ? _c('section', {
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "vertical-align"
  }, [_c('h3', [_vm._v("You've been matched with these people based on focus areas, skills and regions of interest.")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.hideInstructions
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "filter",
    class: {
      noinstructions: _vm.uiHideInstructions
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "matches"
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(user, key) {
      return _c('user-box', {
        key: key,
        attrs: {
          "userid": user
        }
      })
    }))
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('p', [_vm._v("Ordered By Most Recent")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2359667b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Matches.vue
// module id = 684
// module chunks = 1